// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.all_stories_and_contributors_section {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
.all_stories_and_contributors_container {
  width: 90%;
  display: flex;
  flex-direction: row;
}
.all_stories_list_container {
  width: 50%;
  display: flex;
  flex-direction: column;
}
.all_stories_image {
  width: 50%;
  border-radius: 10px 0px 0px 10px;
  transition: transform 0.3s ease-in-out;
  object-fit: cover;
}
.author_text {
  color: #61666d;
  font-family: "Lato";
  width: 80%;
  font-size: 12px;
}
.date_text {
  color: #61666d;
  font-family: "Lato";
  width: 80%;
  font-size: 12px;
}
.viewed_count {
  width: 40%;
  text-align: right;
  padding-right: 5px;
  font-size: 10px;
  padding-left: 2px;
}
.time_text {
  width: 40%;
  text-align: right;
  padding-right: 5px;
  font-size: 10px;
  padding-left: 2px;
}

.all_stories_list_container_card {
  display: flex;
  flex-direction: row;
  margin-top: 40px;
}
.all_stories_image_container {
  width: 50%;
  overflow: hidden;
  border-radius: 10px 0px 0px 10px;
}
.all_stories_image_container:hover .all_stories_image {
  transform: scale(1.1);
}
.all_stories_text_container {
  width: 50%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.author_name_container {
  display: flex;
  flex-direction: row;
  width: 100%;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: 5px;
  justify-content: space-between;
}
.published_date_container {
  display: flex;
  flex-direction: row;
  width: 100%;
  padding-left: 5px;
  padding-right: 5px;
  justify-content: space-between;
}
.card_title_container {
  width: 100%;
  padding-left: 5px;
}
.card_title {
  font-family: "Kufam";
  font-weight: 600;
  font-size: 14px;
}
.sub_title_container {
  line-height: 15px;
  width: 100%;
  padding-left: 5px;
  height: 80px;
  overflow: hidden;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-right: 5px;
}
.sub_title {
  font-family: "Kufam";
  font-size: 11px;
}
.author_text_icon_container {
  width: 20%;
  align-items: flex-start;
}
.user_contribution_title_container {
  width: 90%;
  display: flex;
}
.user_contribution_title {
  color: #111;
  font-family: "kufam";
  font-weight: 700;
}
.top_contributors_section {
  width: 50%;
}
.top_contributors_container {
  display: grid;
  gap: 40px;
  margin-top: 40px;
  position: sticky;
  top: 0;
  flex-direction: row;
  grid-template-columns: 50% 50%;
  width: 80%;
}
.top_contributors_image_container {
  width: 220px;
  position: relative;
  cursor: pointer;
}
.top_contributors_image {
  width: 200px;
  border-radius: 10px;
}
.top_contributors_title {
  margin-left: 60px;
}
.overlay_content {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  width: 150px;
  height: 80px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
  background-color: #fff;
  position: absolute;
  right: 0;
  bottom: 0;
  align-items: center;
  justify-content: center;
}
.overlay_content_container {
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  justify-content: center;
}
.overlay_user_details_icon {
  color: #666376;

  width: 20%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.overlay_user_details_label {
  color: #666376;
  font-size: 10px;
  font-family: "Lato";
  width: 30%;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.overlay_user_details {
  color: #666376;
  font-size: 10px;
  font-family: "Lato";
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.overlay_contributor_name {
  text-align: center;
  font-family: "kufam";
  font-size: 10px;
  font-weight: 600;
}
.all_stories_list_container_card_skeleton {
  width: 90%;
  border-radius: 9px;
  box-shadow: 5px 5px 15px 0px rgba(0, 101, 204, 0.15);
  display: flex;
  flex-direction: row;
  margin-top: 40px;
}
.user_contribution_list_container_skeleton {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 90%;
  margin: 0 auto;
}
.user_contribution_list_skeleton {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 30px;
  margin-top: 10px;
}
.user_contribution_card {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  cursor: pointer;
  border-radius: 10px;
  box-shadow: 5px 5px 15px 0px rgba(0, 101, 204, 0.15);
  position: relative;
}
.user_contribution_card_skeleton_width {
  width: 400px;
  margin: 10px;
  height: 100px;
}
.contributors_image_mobile_view_section {
  width: 90%;
  height: 100px;
  padding-top: 10px;
  padding-bottom: 10px;
}
.contributors_image_mobile_view {
  width: 80px;
  height: 80px;
  border-radius: 40px;
  margin-left: 10px;
}
.recently_added_mobile_container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.load_more_button {
  background-color: var(--become-member-button);
  color: white;
  border: 1px solid var(--become-member-button);
}
.load_more_button:hover {
  background-color: var(--become-member-button-hover) !important;
  color: white !important;
  border: 1px solid var(--become-member-button-hover);
}
.user_contributors_container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.user_contributors_list {
  width: 90%;
  display: grid;
  gap: 30px;
  padding: 4% 0 4% 0;
}
.see_more_button {
  background-color: #00adee !important;
  color: #ffffff !important;
  width: 200px;
}
.user_contribution_title_ta {
  font-weight: 600;
}
.all_stories_button {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}
.top_contributors_banner {
  z-index: 1;
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/styles/layout/user_contribution.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,UAAU;EACV,gCAAgC;EAChC,sCAAsC;EACtC,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,UAAU;EACV,eAAe;AACjB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,UAAU;EACV,eAAe;AACjB;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,gCAAgC;AAClC;AACA;EACE,qBAAqB;AACvB;AACA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,UAAU;EACV,uBAAuB;AACzB;AACA;EACE,UAAU;EACV,aAAa;AACf;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,MAAM;EACN,mBAAmB;EACnB,8BAA8B;EAC9B,UAAU;AACZ;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,0CAA0C;EAC1C,sBAAsB;EACtB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,cAAc;;EAEd,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,oDAAoD;EACpD,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,cAAc;AAChB;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,oDAAoD;EACpD,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;AACf;AACA;EACE,UAAU;EACV,aAAa;EACb,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,6CAA6C;EAC7C,YAAY;EACZ,6CAA6C;AAC/C;AACA;EACE,8DAA8D;EAC9D,uBAAuB;EACvB,mDAAmD;AACrD;AACA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,UAAU;EACV,aAAa;EACb,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;AACrB","sourcesContent":[".all_stories_and_contributors_section {\n  display: flex;\n  justify-content: center;\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n.all_stories_and_contributors_container {\n  width: 90%;\n  display: flex;\n  flex-direction: row;\n}\n.all_stories_list_container {\n  width: 50%;\n  display: flex;\n  flex-direction: column;\n}\n.all_stories_image {\n  width: 50%;\n  border-radius: 10px 0px 0px 10px;\n  transition: transform 0.3s ease-in-out;\n  object-fit: cover;\n}\n.author_text {\n  color: #61666d;\n  font-family: \"Lato\";\n  width: 80%;\n  font-size: 12px;\n}\n.date_text {\n  color: #61666d;\n  font-family: \"Lato\";\n  width: 80%;\n  font-size: 12px;\n}\n.viewed_count {\n  width: 40%;\n  text-align: right;\n  padding-right: 5px;\n  font-size: 10px;\n  padding-left: 2px;\n}\n.time_text {\n  width: 40%;\n  text-align: right;\n  padding-right: 5px;\n  font-size: 10px;\n  padding-left: 2px;\n}\n\n.all_stories_list_container_card {\n  display: flex;\n  flex-direction: row;\n  margin-top: 40px;\n}\n.all_stories_image_container {\n  width: 50%;\n  overflow: hidden;\n  border-radius: 10px 0px 0px 10px;\n}\n.all_stories_image_container:hover .all_stories_image {\n  transform: scale(1.1);\n}\n.all_stories_text_container {\n  width: 50%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n.author_name_container {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  padding-left: 5px;\n  padding-right: 5px;\n  padding-top: 5px;\n  justify-content: space-between;\n}\n.published_date_container {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  padding-left: 5px;\n  padding-right: 5px;\n  justify-content: space-between;\n}\n.card_title_container {\n  width: 100%;\n  padding-left: 5px;\n}\n.card_title {\n  font-family: \"Kufam\";\n  font-weight: 600;\n  font-size: 14px;\n}\n.sub_title_container {\n  line-height: 15px;\n  width: 100%;\n  padding-left: 5px;\n  height: 80px;\n  overflow: hidden;\n  padding-top: 5px;\n  padding-bottom: 5px;\n  padding-right: 5px;\n}\n.sub_title {\n  font-family: \"Kufam\";\n  font-size: 11px;\n}\n.author_text_icon_container {\n  width: 20%;\n  align-items: flex-start;\n}\n.user_contribution_title_container {\n  width: 90%;\n  display: flex;\n}\n.user_contribution_title {\n  color: #111;\n  font-family: \"kufam\";\n  font-weight: 700;\n}\n.top_contributors_section {\n  width: 50%;\n}\n.top_contributors_container {\n  display: grid;\n  gap: 40px;\n  margin-top: 40px;\n  position: sticky;\n  top: 0;\n  flex-direction: row;\n  grid-template-columns: 50% 50%;\n  width: 80%;\n}\n.top_contributors_image_container {\n  width: 220px;\n  position: relative;\n  cursor: pointer;\n}\n.top_contributors_image {\n  width: 200px;\n  border-radius: 10px;\n}\n.top_contributors_title {\n  margin-left: 60px;\n}\n.overlay_content {\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  width: 150px;\n  height: 80px;\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);\n  background-color: #fff;\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  align-items: center;\n  justify-content: center;\n}\n.overlay_content_container {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n}\n.overlay_user_details_icon {\n  color: #666376;\n\n  width: 20%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.overlay_user_details_label {\n  color: #666376;\n  font-size: 10px;\n  font-family: \"Lato\";\n  width: 30%;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n.overlay_user_details {\n  color: #666376;\n  font-size: 10px;\n  font-family: \"Lato\";\n  width: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n.overlay_contributor_name {\n  text-align: center;\n  font-family: \"kufam\";\n  font-size: 10px;\n  font-weight: 600;\n}\n.all_stories_list_container_card_skeleton {\n  width: 90%;\n  border-radius: 9px;\n  box-shadow: 5px 5px 15px 0px rgba(0, 101, 204, 0.15);\n  display: flex;\n  flex-direction: row;\n  margin-top: 40px;\n}\n.user_contribution_list_container_skeleton {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 90%;\n  margin: 0 auto;\n}\n.user_contribution_list_skeleton {\n  display: grid;\n  grid-template-columns: repeat(1, 1fr);\n  gap: 30px;\n  margin-top: 10px;\n}\n.user_contribution_card {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: 100%;\n  cursor: pointer;\n  border-radius: 10px;\n  box-shadow: 5px 5px 15px 0px rgba(0, 101, 204, 0.15);\n  position: relative;\n}\n.user_contribution_card_skeleton_width {\n  width: 400px;\n  margin: 10px;\n  height: 100px;\n}\n.contributors_image_mobile_view_section {\n  width: 90%;\n  height: 100px;\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n.contributors_image_mobile_view {\n  width: 80px;\n  height: 80px;\n  border-radius: 40px;\n  margin-left: 10px;\n}\n.recently_added_mobile_container {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n.load_more_button {\n  background-color: var(--become-member-button);\n  color: white;\n  border: 1px solid var(--become-member-button);\n}\n.load_more_button:hover {\n  background-color: var(--become-member-button-hover) !important;\n  color: white !important;\n  border: 1px solid var(--become-member-button-hover);\n}\n.user_contributors_container {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n.user_contributors_list {\n  width: 90%;\n  display: grid;\n  gap: 30px;\n  padding: 4% 0 4% 0;\n}\n.see_more_button {\n  background-color: #00adee !important;\n  color: #ffffff !important;\n  width: 200px;\n}\n.user_contribution_title_ta {\n  font-weight: 600;\n}\n.all_stories_button {\n  display: flex;\n  justify-content: center;\n  margin-top: 10px;\n}\n.top_contributors_banner {\n  z-index: 1;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
